import { Quote } from '../types';

export const INITIAL_QUOTES: Quote[] = [
  {
    id: 'quote-1',
    text: 'We suffer more often in imagination than in reality.',
    author: 'Seneca',
    category: 'Stoicism',
    created_at: 1728000000000,
    is_active: 1
  },
  {
    id: 'quote-2',
    text: 'The impediment to action advances action. What stands in the way becomes the way.',
    author: 'Marcus Aurelius',
    category: 'Stoicism',
    created_at: 1728000001000,
    is_active: 1
  },
  {
    id: 'quote-3',
    text: 'Do not count the days, make the days count.',
    author: 'Muhammad Ali',
    category: 'Focus',
    created_at: 1728000002000,
    is_active: 1
  },
  {
    id: 'quote-4',
    text: 'Small disciplines repeated with consistency every day lead to great achievements gained slowly over time.',
    author: 'John C. Maxwell',
    category: 'Discipline',
    created_at: 1728000003000,
    is_active: 1
  },
  {
    id: 'quote-5',
    text: 'He who has a why to live can bear almost any how.',
    author: 'Friedrich Nietzsche',
    category: 'Purpose',
    created_at: 1728000004000,
    is_active: 1
  },
  {
    id: 'quote-6',
    text: 'It is not that we have a short time to live, but that we waste a lot of it.',
    author: 'Seneca',
    category: 'Stoicism',
    created_at: 1728000005000,
    is_active: 1
  },
  {
    id: 'quote-7',
    text: 'You have power over your mind - not outside events. Realize this, and you will find strength.',
    author: 'Marcus Aurelius',
    category: 'Resilience',
    created_at: 1728000006000,
    is_active: 1
  },
  {
    id: 'quote-8',
    text: 'First say to yourself what you would be; and then do what you have to do.',
    author: 'Epictetus',
    category: 'Identity',
    created_at: 1728000007000,
    is_active: 1
  }
];
